exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changefirware[data-v-9286a2bc]{padding-right:20px;padding-top:20px}.changefirware .btn[data-v-9286a2bc]{width:100%;text-align:center}\n", ""]);

// exports
